import { GameInfo } from "../../analytics/GameInfo";
import { TickerDelay } from "../../tools/TickerDelay";

export class ReloadTracker {
    private static readonly CHECK_VERSION_DELAY = 300000;
    private static readonly VERSION_REGEXP = /_CVT_GAME_VERSION = "(.*)"/;
    private static readonly TIMESTAMP_QUERY = "timestamp";

    public constructor(
        private readonly gameInfo: GameInfo
    ) { }

    public async startBackgroundTrack(): Promise<void> {
        await this.checkVersion();
    }

    private async checkVersion(): Promise<void> {
        const versionScript = await (await fetch(`${location.origin}/version.js?t=${Date.now()}`)).text();
        const version = versionScript.match(ReloadTracker.VERSION_REGEXP)[1];
        if (version !== this.gameInfo.gameVersion) {
            const searchParams = new URLSearchParams(new URL(location.href).search);
            if (!searchParams.has(ReloadTracker.TIMESTAMP_QUERY)) {
                location.href = `${location.href}${(location.href.charAt(location.href.length - 1) === '/' ? "?" : "&") + `${ReloadTracker.TIMESTAMP_QUERY}=${Date.now()}`}`;
            }
            else {
                searchParams.set(ReloadTracker.TIMESTAMP_QUERY, Date.now().toString());
                location.href = `${location.origin}/?${searchParams}`;
            }
            return;
        }
        await TickerDelay.delay(ReloadTracker.CHECK_VERSION_DELAY);
        requestAnimationFrame(() => this.checkVersion());
    }
}